import dayjs, { Dayjs } from "dayjs";

/** Função responsável por criar uma máscara de % para números */
export function maskPercentage(value?: string): string {
  if (!value) return "";

  // Remove all non-digit characters
  const digits = value.replace(/\D/g, "");

  if (!digits) return "";

  // Special case: exactly "100" (no comma)
  if (digits === "100") {
    return "100%";
  }

  // Limit to 2 digits before the comma
  const intPart = digits.slice(0, 2);
  const decimalPart = digits.slice(2);

  if (decimalPart) {
    return `${intPart},${decimalPart}%`;
  } else {
    return `${intPart}%`;
  }
}

/** Função responsável por verificar e converter Date para dayjs */
export function parseDate(value?: Date): Dayjs | null {
  if (!value) return null;

  if (!dayjs(value).isValid()) return null;

  return dayjs(value);
}

export function formatCurrency(payload?: string) {
  if (!payload) return "";

  // Remove all non-digits
  const numeric = payload.replace(/\D/g, "");

  // Convert to number and divide by 100 to get cents
  const amount = Number(numeric) / 100;

  // Format using Intl
  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
    minimumFractionDigits: 2,
  }).format(amount);
}
